<template>

<core-panel>

	<template v-slot:head>

		<h1>Win Balance</h1>

	</template>

	<template v-slot:body>

        <app-game :item="item" v-for="(item, index) in list" :key="index" :playsAsSubtext="true" :dark="true">

            <div class="players">
						
                <div class="players-item" :class="{'is-green': item.player > item.self, 'is-red': item.player < item.self}">

                    <core-avatar type="player" :item="player" />

                    <div class="players-item-value">{{ item.player | round }}<small>%</small></div>

                </div>
						
                <div class="players-item" :class="{'is-green': item.player < item.self, 'is-red': item.player > item.self}">

                    <core-avatar type="context" />

                    <div class="players-item-value">{{ item.self | round }}<small>%</small></div>

                </div>

            </div>

		</app-game>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'wins',
			list: [],
            player: {}
		}

	},

	methods: {

		response: function(json) {

			this.player = json.player
			this.list = json.wins.list

		}

	}

}

</script>

<style scoped>

.players {
	display: grid;
	grid-template-columns: 54px;
	grid-template-rows: 24px 24px;
	grid-gap: 2px;
}

.players-item {
	display: grid;
	grid-template-columns: 24px 32px;
	grid-gap: 2px;
	height: 24px;
}

.players-item >>> .avatar {
	width: 24px;
	height: 24px;
}

.players-item >>> .avatar-initial {
	font-size: 12px!important;
}

.players-item-value {
	text-align: center;
	border-radius: 4px;
	height: 24px;
	line-height: 24px;
	font-size: 12px!important;
	font-weight: 400;
	color: #fff;
	background-color: #4881bb;
}

.players-item.is-green .players-item-value {
	background-color: #48bb5e;
}

.players-item.is-red .players-item-value {
	background-color: #bb4848;
}

.players-item-value small {
	font-size: 10px;
	opacity: 0.75;
}

</style>